'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSubmittingForm = exports.hasErrors = exports.getValidating = exports.getErrors = exports.getValues = exports.isValidAndPristine = exports.getForm = undefined;
var _constants = require('../constants');

// The whole form
var getForm = exports.getForm = function getForm(state, formId) {
  return state[_constants.NAME][formId];
};

// Only true after successfull form validation and until a field value is updated
var isValidAndPristine = exports.isValidAndPristine = function isValidAndPristine(state, formId) {
  return !!state[_constants.NAME][formId] && !!state[_constants.NAME][formId].validAndPristine;
};

// All field values
var getValues = exports.getValues = function getValues(state, formId) {
  if (state[_constants.NAME][formId]) {
    return state[_constants.NAME][formId].values;
  }
  return {};
};
var getErrors = exports.getErrors = function getErrors(state, formId) {
  if (state[_constants.NAME][formId]) {
    return state[_constants.NAME][formId].errors;
  }
  return {};
};
var getValidating = exports.getValidating = function getValidating(state, formId) {
  if (state[_constants.NAME][formId]) {
    return state[_constants.NAME][formId].fieldsValidating;
  }
  return {};
};

// Form has at least 1 field error
var hasErrors = exports.hasErrors = function hasErrors(state, formId) {
  var errors = false;
  if (state[_constants.NAME][formId]) {
    Object.keys(state[_constants.NAME][formId].errors).forEach(function (name) {
      if (state[_constants.NAME][formId].errors[name]) {
        errors = true;
      }
    });
  }
  return errors;
};

// Whole form is being submitted
var isSubmittingForm = exports.isSubmittingForm = function isSubmittingForm(state, formId) {
  if (state[_constants.NAME][formId]) {
    return state[_constants.NAME][formId].submittingForm;
  }
  return false;
};